import { useContext } from "react";
import { Box } from "@mui/material";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { NEW_SORT } from "../../../../constants";
import { ArrowIcon } from "../../../../assets/icons/icon";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";


export const SortArrow = ({ isAscending, id, disabled }) => (
  <ArrowIcon
    id={id}
    style={{
      ...(isAscending && { transform: "rotate(-0.5turn)" }),
      marginLeft: "4px",
      marginBottom: "4px",
      ...(disabled && { opacity: 0.3, pointerEvents: "none" }),
    }}
  />
);


export const SaleTableHeads = [
  {
    i18nKey: "date",
    showDataKey: "date",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "sidebarOption",
    isArrow: true,
    onClick: (filters, handleFilterChange) => {
      const newSort = filters.sort == "Oldest" ? "Newest" : "Oldest";
      triggerLogEvent(analytics, "bo_txn_sort", { column: "date", sort: newSort });
      handleFilterChange("sort", newSort);
    },
  },
  {
    i18nKey: "type",
    showDataKey: "type",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
    isArrow: true,
    onClick: (filters, handleFilterChange) => {
      const newSort = filters.sort == NEW_SORT.SALE ? NEW_SORT.EXPENSE : NEW_SORT.SALE;
      triggerLogEvent(analytics, "bo_txn_sort", { column: "type", sort: newSort });
      handleFilterChange("sort", newSort);
    },
  },
  {
    i18nKey: "description",
    showDataKey: "description",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "status",
    showDataKey: "status",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "amount",
    showDataKey: "amount",
    rsLabel: true,
    className: "textRight",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
];

const TransactionListTableHead = ({
  filters,
  handleFilterChange,
  isShowAll,
  disabled = false,
}) => {
  const [I18n] = useContext(LanguageContext);

  return (
    <Box className="invoiceListTableHeader">
      {SaleTableHeads.map((headInfo, ind) => (
        <Box
          key={ind}
          onClick={
            headInfo.onClick && !disabled
              ? () => headInfo.onClick(filters, handleFilterChange)
              : undefined
          }
          className={`invListTableHeaderCol fiveColumn ${headInfo.className} ${
            headInfo.columnClassName || ""
          } ${headInfo.onClick && !disabled ? "cursorPointer" : ""}`.trim()}
        >
          {!("displayOn" in headInfo) && (
            <ParagraphText className={`fontSize12 fontWeight500 newLightColor ${styles.headerItem}`}>
              {I18n[headInfo.i18nKey]}

              {headInfo.isArrow && isShowAll && (
                <SortArrow
                  isAscending={
                    headInfo.showDataKey === "date"
                      ? filters?.sort == "Oldest"
                      : headInfo.showDataKey === "type"
                      ? filters?.sort == NEW_SORT.SALE
                      : null
                  }
                  disabled={disabled}
                />
              )}
            </ParagraphText>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default TransactionListTableHead;